import { ShopifyColor, StripeColor } from "@intelligems/ig-theme";
import { hexToRgbA } from "@intelligems/ig-utils";

export const ProviderColors = {
  stripe: {
    panelBackgroundColor: hexToRgbA(StripeColor, 0.05),
    tableHeaderBackgroundColor: "#F7F7FF",
  },

  shopify: {
    panelBackgroundColor: hexToRgbA(ShopifyColor, 0.1),
    tableHeaderBackgroundColor: "#F1F6E9",
  },
};
